<script setup>

import NumberOnlyInput from "@/components/common/input/NumberOnlyInput"
import MultiSearchDropDown from "@/components/common/input/MultiSearchDropDown"
import PurchaseOrderItemDetail from "@/classes/component-classes/PurchaseOrderItemDetail";
import PurchaseOrderItemDetailExtended from "@/classes/component-classes/PurchaseOrderItemDetailExtended";

import {useGetValidatedFields} from "@/composables/common/useGetValidatedFields";

import {ref, onMounted} from 'vue';

const localArray = ref([]);

const emits = defineEmits(['entry-update'])

const props = defineProps({

  modelValue: {
    type: Array, default: function () {
      return []
    },
  },

  requiredFields: {type: Array, default: []},
  validationFail: Boolean,
  height: Number

})

function addNewItem(line, index) {

  let valid = validate(line);

  if (valid) {

    line.showAddButton = false;
    line.readOnly = true;

    localArray.value.push(new PurchaseOrderItemDetailExtended());
    props.modelValue.push(new PurchaseOrderItemDetail());

    modelValueUpdate(line, index);

  }

}

function validate(line) {

  // if(!line.containerType || !line.teu || !line.containerNumber || !line.sealNumber) return false;

  return true;

}

function modelValueUpdate(line, index) {

  // Collect the pure model keys and update the values from the current local line
  for (const propName in props.modelValue[0]) {
    props.modelValue[index][propName] = line[propName]
  }

}

function prepareDelete(line) {
  line.isDeleting = true;
}

function cancelDelete(line) {
  line.isDeleting = false;
}

function removeItem(index, line) {

  localArray.value.splice(index, 1);
  props.modelValue.splice(index, 1);

  localArray.value[localArray.value.length - 1].isEditing = false;
  localArray.value[localArray.value.length - 1].readOnly = false;

}

function editItem(line) {

  localArray.value.forEach(item => {
    item.readOnly = true;
  });

  line.readOnly = false;
  line.isEditing = true;

  // Take the add button away if editing a line
  localArray.value[localArray.value.length - 1].isEditing = true;

}

function acceptEdit(line, index) {

  let valid = validate(line)

  if (valid) {

    if (index === localArray.value.length - 1) {
      props.modelValue.push(new PurchaseOrderItemDetail())
    }

    modelValueUpdate(line, index);

    line.readOnly = true;
    localArray.value[localArray.value.length - 1].isEditing = false;
    localArray.value[localArray.value.length - 1].readOnly = false;
  }

}

onMounted(() => {

  // Set memory reference from local data
  let itemDetails = localArray.value

  props.modelValue.forEach(function (item) {

    // Cast the pure model class into the local extended class
    let itemDetail = {...new PurchaseOrderItemDetailExtended(), ...item}

    // Set all correct props for returning data for button actions
    itemDetail.showAddButton = false;
    itemDetail.readOnly = true;

    itemDetails.push(itemDetail)
  })

  // Add a new empty line after the current container
  itemDetails.push(new PurchaseOrderItemDetailExtended())

})

</script>

<template>
  <div class="cmp-purchase-order-item-details">
    <div class="cmp-purchase-order-item-details_labels">
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'productCode')}">Product Code</div>
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'productDescription')}" style="font-size: 12px">Product Description</div>
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'qtyRequired')}">Qty Required</div>
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'qtyReceived')}">Qty Received</div>
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'qtyRemaining')}">Qty Remaining</div>
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'weight')}" style="font-size: 12px">Weight</div>
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'unitOfWeight')}">Unit Of Weight</div>
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'itemPrice')}">Item Price</div>
      <div :class="{'global-required-field': useGetValidatedFields(requiredFields, 'lineItemTotalPrice')}">Line Item TotalPrice</div>
    </div>
    <div class="cmp-purchase-order-item-details_container" :style="{ height: props.height + 'px' }">
      <div v-for="(line, index) in localArray" class="cmp-purchase-order-item-details_wrapper" :key="index">

        <TextInput
            :width="230">

        </TextInput>
        <TextInput
        :width="380">

        </TextInput>
        <NumberOnlyInput
            :width="114">

        </NumberOnlyInput>
        <NumberOnlyInput
            :width="116">

        </NumberOnlyInput>
        <NumberOnlyInput
            :width="116">

        </NumberOnlyInput>
        <NumberOnlyInput
            :width="125">

        </NumberOnlyInput>
        <MultiSearchDropDown
            :width="265"
            :allowCustomValue="false"
            :maxLength="50"
            :selectPrimitiveValue="true">
        </MultiSearchDropDown>
        <NumberOnlyInput
            :width="125">

        </NumberOnlyInput>
        <NumberOnlyInput
            :width="140">

        </NumberOnlyInput>

        <div v-if="line.showAddButton && !line.isEditing" class="cmp-purchase-order-item-details_icons" title="Add New Line">
          <!--          <Button type="toolbar" text="Add" @on-click="addContainer(line, index)"></Button>-->
          <i @click="addNewItem(line, index)" class="fa-solid fa-circle-plus global-add-icon"></i>
        </div>
        <div v-if="line.readOnly && !line.isDeleting" class="cmp-purchase-order-item-details_icons" title="Edit Line">
          <!--          <Button type="success" text="Edit" @on-click="editContainer(line)"></Button>-->
          <i @click="editItem(line)" class="fa-solid fa-pen-to-square" style="color: #37798a"></i>
        </div>
        <div v-if="line.isDeleting" class="cmp-purchase-order-item-details_icons" title="Confirm Delete">
          <!--          <Button type="info" text="Yes" @on-click="removeContainer(index, line)"></Button>-->
          <i @click="removeItem(index, line)" class="fa-solid fa-solid fa-trash-check" style="color: #b0752a"></i>
        </div>
        <div v-if="!line.readOnly && line.isEditing && !line.isDeleting" class="cmp-purchase-order-item-details_icons" title="Accept Changes">
          <!--          <Button type="secondary" text="Accept" @on-click="acceptEdit(line, index)"></Button>-->
          <i @click="acceptEdit(line, index)" class="fa-solid fa-circle-check" style="color: #3f9968"></i>
        </div>
        <div v-if="!line.showAddButton && !line.isDeleting" class="cmp-purchase-order-item-details_icons" title="Delete">
          <!--          <Button type="danger" text="Delete" @on-click="prepareDelete(line)"></Button>-->
          <i  @click="prepareDelete(line)" class="fa-solid fa-trash" style="color: #832222"></i>
        </div>
        <div v-if="line.isDeleting" class="cmp-purchase-order-item-details_icons" title="Do Not Delete">
          <!--          <Button type="secondary" text="No" @on-click="cancelDelete(line)"></Button>-->
          <i @click="cancelDelete(line)" class="fa-solid fa-ban" style="color: #832222;"></i>
        </div>
      </div>
    </div>
  </div>

</template>


<style lang="scss" scoped>

.cmp-purchase-order-item-details {

  &_wrapper {
    width: 940px;
    display: flex;
    gap: 4px;
  }

  &_wrapper > div {
    margin-bottom: 3px;
  }

  &_container {
    height: 60px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  &_labels {
    margin-bottom: 3px;
    font-size: 13px;
    display: grid;
    grid-template-columns: 229px 379px 111px 114px 114px 123px 263px 123px 137px;

    gap: 6px;
  }

  &_labels div {
    color: #454545;
    font-weight: bold;
    font-size: 12px;
    display: flex;
  }

  &_icons {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 20px;
    margin-left: 10px;
  }

}

</style>
